import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Home,
  PieChart,
  Map,
  Clock,
  TrendingUp,
  Calculator,
  Globe2,
  Activity,
  AlertTriangle,
} from 'lucide-react';

const HORMUZ_PAGES = [
  {
    path: '/strait-of-hormuz',
    title: 'Overview',
    icon: Home,
    description: 'Complete guide to the Strait of Hormuz',
  },
  {
    path: '/strait-of-hormuz/statistics',
    title: 'Statistics',
    icon: PieChart,
    description: 'Key metrics and data',
  },
  {
    path: '/strait-of-hormuz/shipping-routes',
    title: 'Shipping Routes',
    icon: Map,
    description: 'Tanker routes and navigation',
  },
  {
    path: '/strait-of-hormuz/historical-timeline',
    title: 'Historical Timeline',
    icon: Clock,
    description: 'Major incidents and events',
  },
  {
    path: '/strait-of-hormuz/economic-impact',
    title: 'Economic Impact',
    icon: TrendingUp,
    description: 'Oil price and trade effects',
  },
  {
    path: '/strait-of-hormuz/risk-dashboard',
    title: 'Risk Dashboard',
    icon: AlertTriangle,
    description: 'Live risk score monitoring',
  },
  {
    path: '/strait-of-hormuz/oil-impact-calculator',
    title: 'Oil Impact Calculator',
    icon: Calculator,
    description: 'Price impact simulator',
  },
  {
    path: '/strait-of-hormuz/live-updates',
    title: 'Live Updates',
    icon: Activity,
    description: 'Real-time news feed',
  },
  {
    path: '/strait-of-hormuz/countries-dependent',
    title: 'Countries Dependent',
    icon: Globe2,
    description: 'Import dependencies analysis',
  },
];

/**
 * Navigation component for Strait of Hormuz hub pages
 * Provides internal linking for SEO and user experience
 */
const HormuzHubNav = ({ className = '' }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <nav
      className={`mb-8 rounded-stitch-xl border border-slate-200/80 bg-slate-50/80 p-5 dark:border-outline-variant/15 dark:bg-surface-container-low ${className}`}
      aria-label="Strait of Hormuz Hub Navigation"
    >
      <h2 className="mb-4 font-headline text-sm font-bold uppercase tracking-wide text-slate-800 dark:text-primary">
        Strait of Hormuz Authority Hub
      </h2>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-4">
        {HORMUZ_PAGES.map((page) => {
          const Icon = page.icon;
          const isActive = currentPath === page.path;
          return (
            <Link
              key={page.path}
              to={page.path}
              className={`flex items-center gap-2 rounded-stitch-lg px-3 py-2.5 text-sm transition-colors ${
                isActive
                  ? 'bg-secondary-container font-medium text-on-secondary-container ring-1 ring-outline-variant/20 dark:shadow-intel-glow-tertiary'
                  : 'border border-transparent bg-white/60 text-slate-600 hover:bg-white dark:bg-surface-container/60 dark:text-on-surface-variant dark:hover:bg-surface-container-high'
              }`}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon className="h-4 w-4 shrink-0 opacity-90" />
              <span className="truncate font-medium">{page.title}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default HormuzHubNav;
